function getPrecision(dollarAmount) {
  const hasCents = dollarAmount % 1 !== 0;
  return hasCents ? 2 : 0;
}

export function compactCurrencyFilter(price) {
  if (price === 0) {
    return 'FREE';
  }
  return `$${price
    .toFixed(getPrecision(price))
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
}

function checkForIntl() {
  return !!(Intl && typeof Intl === 'object' && typeof Intl.NumberFormat === 'function');
}

// added this, might be better to use native javascript number formatter that regex
export function priceFormatter(price, minimumFractionDigits = 2) {
  if (checkForIntl()) {
    const formatter = new Intl.NumberFormat('en-us', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits,
    });
    return formatter.format(price, minimumFractionDigits);
  }
  return compactCurrencyFilter(price);
}

export default compactCurrencyFilter;
